import { Grid, Typography, Card, CardContent, Skeleton } from '@mui/material';
import { Spacer, Row } from '../../../components';
import { formatTwoDecimalPlaces } from '../../../helpers/utilityFunctions';

interface InvoiceDetailsProps {
  invoiceTotal?: number;
  loading?: boolean;
}

const OutstandingInvoice: React.FC<InvoiceDetailsProps> = ({ invoiceTotal, loading }) => {
  return (
    <Grid container flexDirection='column' alignItems='center'>
      <Typography variant='p18SemiBold' color='secondary.dark'>
        Outstanding invoice total
      </Typography>
      <Spacer height='xxs' />
      <Card variant='innerCard' style={{ minWidth: '200px', padding: '0px 10px 0px 10px' }}>
        <CardContent>
          <Row style={{ justifyContent: 'center' }}>
            {loading ? (
              <Skeleton
                variant='rectangular'
                animation='wave'
                width={120}
                height={25}
                sx={{ borderRadius: 2, mt: 1 }}
              />
            ) : invoiceTotal !== undefined ? (
              <>
                <Typography color='info.main' style={{ display: 'inline' }} variant='subtitle1'>
                  $
                </Typography>
                <Typography
                  color='secondary.dark'
                  style={{ display: 'inline' }}
                  variant='subtitle1'>
                  {formatTwoDecimalPlaces(invoiceTotal / 100.0)}
                </Typography>
              </>
            ) : (
              <Typography variant='p14' color='error.main'>
                Unable to load total
              </Typography>
            )}
          </Row>
          <Row style={{ justifyContent: 'center' }}>
            {loading ? (
              <Skeleton
                variant='rectangular'
                animation='wave'
                width={80}
                height={16}
                sx={{ borderRadius: 2, mt: 1.2 }}
              />
            ) : invoiceTotal !== undefined ? (
              <Typography variant='p12SemiBold' color='secondary.main'>
                due today
              </Typography>
            ) : null}
          </Row>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default OutstandingInvoice;
